import ProductSlider from '@/organisms/ProductSlider'
import Product from '@/ts/Product'
import SliderHeader from '@/views/common/SliderHeader'

function Slider({ products }: { products?: Product[] }) {
  if (!products || products.length <= 0) return null

  const count = products.length
  const type = products[0].type
  const nickname = products[0]?.creator.nickname

  return (
    <section className="relative flex flex-col space-y-6 md:space-y-8">
      <SliderHeader count={count} type={type} nickname={nickname} asCreator />
      <ProductSlider products={products} />
    </section>
  )
}

export default Slider
